'use strict';

import jQuery from 'jquery';

const SEARCH_PANEL_COMPONENT_ATTR = 'data-search-panel-toggle';
const SEARCH_PANEL_COMPONENT_SELECTOR = '[' + SEARCH_PANEL_COMPONENT_ATTR + ']';

const SEARCH_PANEL_ATTR = 'data-search-panel';
const SEARCH_PANEL_CLOSE = '[data-search-panel-close]';

const IS_HIDDEN_CLASS = 'is-hidden';
const IS_VISIBLE_CLASS = 'is-visible';

const EVENT_SEARCH_PANEL_CLOSE = 'events-search-panel-close';

const $window = jQuery(window);
const $body = jQuery('body');

export default class SearchPanel {

    constructor(element) {
        const component = this;

        component.$element = jQuery(element);

        component.targetElementID = component.$element.attr(SEARCH_PANEL_COMPONENT_ATTR);
        component.$targetElement = $body.find('[' + SEARCH_PANEL_ATTR + '="' + component.targetElementID + '"]')

        component.$targetElementButtonClose = component.$targetElement.find(SEARCH_PANEL_CLOSE);

        component.bindGlobalEventListeners();

        component.$element.on('click', () => {
            component.openPanel();
        });

        component.$targetElementButtonClose.on('click', () => {
            $window.trigger(EVENT_SEARCH_PANEL_CLOSE);
        });
    }

    bindGlobalEventListeners() {
        const component = this;

        $window.on(EVENT_SEARCH_PANEL_CLOSE, () => {
            component.closePanel();
        });
    }

    openPanel() {
        const component = this;

        component.$targetElement.removeClass(IS_HIDDEN_CLASS).addClass(IS_VISIBLE_CLASS);
    }

    closePanel() {
        const component = this;

        component.$targetElement.removeClass(IS_VISIBLE_CLASS).addClass(IS_HIDDEN_CLASS);
    }
}

jQuery(SEARCH_PANEL_COMPONENT_SELECTOR).each((index, element) => new SearchPanel(element));
